"use client";

import {
  StatsigProviderWrapper as BaseStatsigProviderWrapper,
  StatsigUserInfo,
} from "@punchup/analytics/statsig/provider";
import useSession from "@/hooks/useSession";

/**
 * App-specific Statsig wrapper that integrates with Supabase auth.
 * Uses the shared StatsigProviderWrapper from @punchup/analytics.
 */
export const StatsigProviderWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const session = useSession();

  // Map session to StatsigUserInfo
  // undefined = still loading, null = logged out, object = logged in
  const user: StatsigUserInfo | undefined =
    session === undefined
      ? undefined
      : session === null
        ? null
        : {
            id: session.user?.id,
            createdAt: session.user?.created_at,
          };

  return (
    <BaseStatsigProviderWrapper user={user}>
      {children}
    </BaseStatsigProviderWrapper>
  );
};
